var RegisterValidate = $.extend({/* RegisterValidate */}, BaseComponent, {

	componentSelector: '#complete-data',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).validate({
			rules: {
				nif: {
				  required: true,
				  nifES: true
				},
				birthdate: {
					required: true
				},
				po: {
					required: true,
					digits: true
				},
               	email: {
                    email: true,
                    requireFromGroup: [1, '.mail-or-mobile-validation']
                },
               	mobile: {
                    digits: true,
                    requireFromGroup: [1, '.mail-or-mobile-validation']
                },
			},
			groups: {
                myGroup: "email mobile"
            },
			submitHandler: function(form) {
				form.submit();
			},
            errorPlacement: function (error, element) {
                if (element.attr('id') == 'birthdate') {
                    error.insertAfter((element).parents('.input-with-icon-calendar'));
                } else {
                    error.insertAfter(element);
                }
            }
		});

		$(element).find('#register-submit').click((function(event) {
			event.preventDefault();
			$(element).submit();
		}).bind(this));

	}

})